import _get from 'lodash/get'

import {
    RECEIVE_SELF_EMPLOYMENT_EXPENSES,
    REMOVE_SELF_EMPLOYMENT_EXPENSE,
    REQUEST_SELF_EMPLOYMENT_EXPENSES,
} from '../actions'
import { removeItemsById, updateOrAddItemsById } from '../helpers'

export default (
    state = {
        items: [],
        isFetching: null,
        fetchSuccessful: null,
    },
    action
) => {
    const { type, data, meta } = action

    switch (type) {
        case REQUEST_SELF_EMPLOYMENT_EXPENSES: {
            return { ...state, isFetching: true }
        }

        case RECEIVE_SELF_EMPLOYMENT_EXPENSES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, items, isFetching: false, ...meta }
        }

        case REMOVE_SELF_EMPLOYMENT_EXPENSE: {
            const currentItems = [..._get(state, ['items'], [])]

            const id = _get(data, ['id'], null)

            const items = removeItemsById({ currentItems, id })

            return { ...state, items, ...meta }
        }

        default:
            return state
    }
}
